<template>
    <div class="field has-addons">
        <div class="control dropdown" ref="country">
            <div class="dropdown-trigger" style="margin: auto;">
                <button
                    class="button"
                    aria-haspopup="true"
                    aria-controls="dropdown-menu"
                    @click="toggleActive()"
                    @blur="toggleActive(false)"
                >
                    <span>
                        <span class="icon">
                            <i
                                v-if="current"
                                :class="[`flag-icon-${current.country}`, 'flag-icon']"
                            ></i>
                        </span>
                    </span>
                    <span class="icon is-small">
                        <i class="fas fa-angle-down" aria-hidden="true"></i>
                    </span>
                </button>
            </div>
            <div class="dropdown-menu" id="dropdown-menu" role="menu">
                <div class="dropdown-content" style="overflow: auto; max-height: 200px;">
                    <a
                        v-for="phone of phoneArray"
                        :class="[{ 'is-active': phone === current }, 'dropdown-item']"
                        @click="selectCountry(phone);"
                    >
                        <span>
                            <span class="icon">
                                <i :class="[`flag-icon-${phone.country}`, 'flag-icon']"></i>
                            </span>
                            +{{ phone.code }}
                        </span>
                    </a>
                </div>
            </div>
        </div>
        <div class="control column" style="display: table-cell; padding-left: 0;">
            <input
                :value="displayValue"
                :class="[{ 'is-danger': errors.has($attrs['data-vv-name']) }, 'input']"
                v-bind="$attrs"
                v-validate="'required|phoneNumber'"
                ref="input"
                @change="handleInputChange"
                @keydown="handleInputChange"
            />
        </div>
    </div>
</template>

<script>
const minPhoneLength = 9;

const phoneMap = Object.freeze({
    am: { mask: '+374xxxxxxxxxxxx' },
    az: { mask: '+994xxxxxxxxxxxx' },
    by: { mask: '+375xxxxxxxxxxxx' },
    ee: { mask: '+372xxxxxxxxxxxx' },
    gb: { mask: '+44xxxxxxxxxxxxx' },
    ge: { mask: '+9955xxxxxxxxxxx' },
    il: { mask: '+972xxxxxxxxxxxx' },
    in: { mask: '+91xxxxxxxxxxxxx' },
    kg: { mask: '+996xxxxxxxxxxxx' },
    kr: { mask: '+82xxxxxxxxxxxxx' },
    kz: { mask: '+77xxxxxxxxxxxxx' },
    lt: { mask: '+370xxxxxxxxxxxx' },
    lv: { mask: '+371xxxxxxxxxxxx' },
    md: { mask: '+373xxxxxxxxxxxx' },
    pa: { mask: '+507xxxxxxxxxxxx' },
    ru: { mask: '+7xxxxxxxxxx' },
    th: { mask: '+66xxxxxxxxxxxxx' },
    tj: { mask: '+992xxxxxxxxxxxx' },
    tr: { mask: '+90xxxxxxxxxxxxx' },
    ua: { mask: '+380xxxxxxxxxxxx' },
    uz: { mask: '+998xxxxxxxxxxxx' },
    vn: { mask: '+84xxxxxxxxxxxxx' }
});

const phoneArray = Object.freeze(
    Object.keys(phoneMap)
        .map(country => {
            const mask = phoneMap[country].mask.slice(1);
            const index = mask.indexOf('x');
            const code = mask.substring(0, index);
            const totalLength = code.length + mask.substring(index).length;
            return { country, code, mask, totalLength, regexp: new RegExp(`\\b\\d{0,${totalLength}}`) };
        })
        .sort((item1, item2) => item1.code - item2.code)
);

const find = (codeToMatch = '') => {
    if (!codeToMatch) {
        return {};
    }

    const phoneData = phoneArray.find(({ code }) => code === codeToMatch || code.startsWith(codeToMatch));
    return phoneData ? { phoneData, codeToMatch } : find(codeToMatch.substring(0, codeToMatch.length - 1));
};

export default {
    name: 'phone-number',
    inject: ['$validator'],
    props: {
        inputValue: { required: true, default: '' }
    },
    data: function() {
        const current = phoneArray[0];
        return { phoneArray, current, value: current.code };
    },
    computed: {
        displayValue: function() {
            return this.value && `+${this.value}`;
        }
    },
    created() {
        this.$validator.extend('phoneNumber', {
            getMessage: () => this.$t('payment system.validation.phone number.format'),
            validate: () =>
                this.value &&
                this.current &&
                this.current.regexp.test(this.value) &&
                this.value.length >= minPhoneLength &&
                this.value.length <= this.current.totalLength
        });
    },
    methods: {
        handleInputChange() {
            setTimeout(() => {
                const inputValue = this.$refs.input.value.replace(/\D/g, '');
                const { phoneData, codeToMatch } = find(inputValue);
                phoneData && (this.current = phoneData);
                this.value = this.current
                    ? inputValue.startsWith(this.current.code)
                        ? inputValue.match(this.current.regexp)[0]
                        : codeToMatch
                    : null;
                this.$refs.input.value = this.displayValue || '';
                this.$emit('update:inputValue', this.value);
            });
        },
        selectCountry(phoneData) {
            this.value = (this.value ? this.value.replace(this.current.code, phoneData.code) : phoneData.code).substring(
                0,
                phoneData.totalLength
            );
            this.current = phoneData;
        },
        toggleActive(isActive) {
            const classList = this.$refs.country.classList;
            isActive === undefined
                ? classList.toggle('is-active')
                : isActive
                ? classList.add('is-active')
                : setTimeout(() => classList.remove('is-active'), 200);
            return true;
        }
    }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/common/payments/phone-number.vue